import React, { useEffect, useState } from 'react'
import { BiLogoGithub, BiLogoLinkedin,BiLogoGmail } from "react-icons/bi"
import { HiOutlineArrowLongRight } from "react-icons/hi2"

const Landing = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1200);
    useEffect(() => {
        window.addEventListener("resize", () => {
          const ismobile = window.innerWidth < 1200;
          if (ismobile !== isMobile) setIsMobile(ismobile);
        }, false);
      }, [isMobile]);
  return (
    <div id='home' className="main font-vic w-screen overflow-x-hidden  h-full md:h-screen py-28 md:py-8">
        <div className="flex flex-col-reverse md:flex-row  w-full gap-5 h-full px-4 md:pl-10 text-white">
            <div className="flex flex-row h-full md:flex-col justify-start md:justify-center cursor-pointer items-center gap-6">
                <a href='https://github.com/Madaraka02' target='_blank' className="">
                    <BiLogoGithub size={20}/>
                </a>
                <a href='www.linkedin.com/in/victormadaraka' target='_blank' className="">
                    <BiLogoLinkedin size={20}/>
                </a>
                <a href="mailto:victormadaraka@gmail.com" className="">
                    <BiLogoGmail size={20}/>
                </a>

            </div>
            <div className="flex-1 py-6 md:py-32 pl-0 md:pl-28 h-full justify-center flex items-center">
                <div className={`grid ${isMobile ? 'grid-cols-1':'grid-cols-2'} gap-4 w-full  place-items-center`}>
                    <div className="flex flex-col gap-3">
                        <p className='text-[36px]'>Full stack developer</p>
                        <p className='text-[20px]'>
                        Am a fullstack developer with over 2 years of hands-on experience in Python, Javascript and Typescript. My passion for crafting top-notch digital solutions has led me on a dynamic journey through the realms of frontend and backend development. With a track record of turning concepts into polished applications, I specialize in building seamless user experiences while ensuring robust functionality.
                        </p>


                    </div>
                    <div className="">
                        <img src="https://www.ovhcloud.com/sites/default/files/styles/large_screens_1x/public/2020-08/UseCase_OVHcloud-dedicated-servers-for-AI-and-machine-learning%402x.png" alt="" />
                    </div>
                </div>
            </div>
            {!isMobile &&
            <div className="flex flex-row gap-2 rotate-90 h-full justify-end">
                <div className="flex items-center gap-2">

                <p className="tracking-widest ">
                Scroll down
                </p>
                <HiOutlineArrowLongRight size={40}/>
                </div>
            </div>}

        </div>
    </div>
  )
}

export default Landing